<template>
    <section v-if="noFilterResults || noSearchResults" class="empty-results">
        <span class="empty-results-header">{{ header }}</span>
        <span class="empty-results-description">{{ description }}</span>
    </section>
</template>

<script>

export const HEADER = {
    BOTH: 'There were no results matching your search/filter criteria.',
    FILTER: 'You have no {filter} broadcasts',
    SEARCH: 'Your search for {search} returned no results',
};

export const DESCRIPTION = {
    BOTH: 'Try adjusting your search query or filters',
    FILTER: 'Try changing your filter settings',
    SEARCH: 'Try searching for something else',
};

export default {

    HEADER,
    DESCRIPTION,

    props: {
        filter: {
            type: String,
            default: '',
        },
        noFilterResults: Boolean,
        noSearchResults: Boolean,
        search: {
            type: String,
            default: '',
        },
    },

    computed: {
        header() {
            if (this.noFilterResults && this.noSearchResults) {
                return HEADER.BOTH;
            }

            if (this.noFilterResults) {
                return HEADER.FILTER.replace('{filter}', this.filter);
            }

            if (this.noSearchResults) {
                return HEADER.SEARCH.replace('{search}', this.search);
            }

            return '';
        },

        description() {
            if (this.noFilterResults && this.noSearchResults) {
                return DESCRIPTION.BOTH;
            }

            if (this.noFilterResults) {
                return DESCRIPTION.FILTER;
            }

            if (this.noSearchResults) {
                return DESCRIPTION.SEARCH;
            }

            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
    .empty-results {
        display: flex;
        flex-direction: column;
        padding-top: 2rem;
        align-items: center;
    }

    .empty-results-header {
        font-size: 1.3rem;
        font-weight: 300;
        color: $color-gray-700;
        padding-bottom: 1rem;
    }

    .empty-results-description {
        color: $color-gray-700;
    }
</style>
